import {Dispatch, SetStateAction, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {capitalize, cloneDeep} from "lodash";
import {
  BiodiversityFiltersFE,
  fromFeToBeBiodiversityTableFilters
} from "../../../../types/internal/tables/biodiversityTable";
import {useLazyGetAssetBiodiversityRelatedOptionsForInfiniteScrollingQuery} from "../../../../redux/api/asset";
import {parseOptions} from "../../../../redux/api/assets";
import {OptionLabelValue} from "../../../../types/internal/OptionLabelValue";
import NEWListWithSearchFilter from "../../../common/filters/NEWListWithSearchFilter";
import {getTranslationBiodiversityTableColumnKey} from "../../../../utils/translation";

export default function BiodiversityRelatedOptionsFilter({field, assetUuid, filters, setFilters}: {
  assetUuid: string,
  field: 'data_source' | 'name' | 'designation_type' | 'pa_id' ,
  filters: BiodiversityFiltersFE,
  setFilters: Dispatch<SetStateAction<BiodiversityFiltersFE>>
}) {

  const [getData, {
    data,
    isLoading,
    isFetching,
    isUninitialized,
    originalArgs,
  }] = useLazyGetAssetBiodiversityRelatedOptionsForInfiniteScrollingQuery()
  const [querySearch, setQuerySearch] = useState<string>('');
  const options: OptionLabelValue[] = useMemo(() => parseOptions(data?.results || []), [data?.results]);
  const total = data?.count || 0;
  const {t} = useTranslation();
  const placeholder = capitalize(t('table.filterPlaceholder', {column: t(getTranslationBiodiversityTableColumnKey(field))}));
  const selectedFilters = filters[field] || [];

  //const isExclude = filters.excludedFilters.some(el => el === field)

  const {[field]: currentFilter, ...biodiversityFiltersWithoutCurrentFilter} = filters
  const biodiversityTableFiltersWithoutCurrentFilterRef = useRef<BiodiversityFiltersFE>(biodiversityFiltersWithoutCurrentFilter)

  useEffect(() => {
    const {[field]: currentFilter, ...biodiversityFiltersWithoutCurrentFilter} = filters
    biodiversityTableFiltersWithoutCurrentFilterRef.current = biodiversityFiltersWithoutCurrentFilter
  }, [field, filters]);

  const handleGetNext = useCallback(() => {
    getData({
      column: field,
      ...!!querySearch && {column_search: querySearch},
      ...fromFeToBeBiodiversityTableFilters(biodiversityTableFiltersWithoutCurrentFilterRef.current),
      page: (originalArgs?.page || 0) + 1,
      page_size: 15,
      assetUuid
    });
  }, [assetUuid, field, getData, originalArgs?.page, querySearch]);

  useEffect(() => {
    getData({
      column: field,
      ...!!querySearch && {column_search: querySearch},
      ...fromFeToBeBiodiversityTableFilters(biodiversityTableFiltersWithoutCurrentFilterRef.current),
      page: 1,
      page_size: 15,
      assetUuid
    });
  }, [assetUuid, field, getData, querySearch]);

  return <>
    <NEWListWithSearchFilter
      getNext={handleGetNext}
      options={options}
      selectedOptions={selectedFilters}
      setSelectedOptions={values => {
        if (values.length) {
          setFilters(prevState => ({...prevState, [field]: values}));
        } else {
          setFilters(prevState => {
            const copyState = cloneDeep(prevState)
            delete copyState[field]
            return copyState
          })
        }
      }}
      total={total}
      isLoadingOptions={isLoading || isFetching || isUninitialized}
      querySearch={querySearch}
      setQuerySearch={setQuerySearch}
      search={{placeholder}}

      //isExcludeFeature={true}
      //isExclude={isExclude}
      setExcludeMode={() => {
        setFilters(prevState => {
          const copyState = cloneDeep(prevState)
          delete copyState[field]
          return {
            ...copyState,
            //excludedFilters: [...prevState.excludedFilters, field]
          }
        })
      }}
      setDeclarativeMode={() => {
        setFilters(prevState => {
          const copyState = cloneDeep(prevState)
          delete copyState[field]
          return {
            ...copyState,
            //excludedFilters: prevState.excludedFilters.filter(el => el !== field)
          }
        })
      }}
    />
  </>;
}